var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,12H8V5h3v6C11,11.4,10.4,12,10,12z M0,1c0-0.4,0.6-1,1-1h9c0.4,0,1,0.6,1,1v3H0V1z M3,12H1     c-0.4,0-1-0.6-1-1V5h3V12z M7,12H4V5h3V12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnIcon);
export default __webpack_public_path__ + "static/media/column-icon.62ef47dd3930fccb7d3bf3c64c2c5708.svg";
export { ForwardRef as ReactComponent };